import React from 'react';
import { ContentArea } from '../ContentArea/ContentArea.tsx';
import { ReactLenis } from 'lenis/react';
const lenisOptions = {
    lerp: 0.1,
    duration: 0.6,
    easing: (t) => 1 - Math.pow(1 - t, 3),
    smoothTouch: true, //smooth scroll for touch devices
    smooth: true
};
export const StartPage = ({ content }) => {
    if (!content) {
        return null;
    }
    return (React.createElement(ReactLenis, { root: true, options: lenisOptions },
        React.createElement(ContentArea, { contentArea: content.freeArea })));
};
